<template>
	<div class="lb">
		<div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
	</div>
</template>


<script>
import * as methods from './method.js'
export default {
	name: 'template.scope26',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: 'T型分组柱状图-scope26',
			timer: null,
			defaultdata: [
				{ value1: '4月', value2: '系列一', value3: '10', value4: '%' },
				{ value1: '5月', value2: '系列一', value3: '20' },
				{ value1: '6月', value2: '系列一', value3: '30' },
				{ value1: '7月', value2: '系列一', value3: '40' },
				{ value1: '8月', value2: '系列一', value3: '50' }
			],
			valueMap: [
				{ name: '横轴', key: 'value1' },
				{ name: '柱图名称', key: 'value2' },
				{ name: '柱图数值', key: 'value3' },
				{ name: '单位', key: 'value4' },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.barMian);
			let myData = [];
			let numA = [];
			let unit = this.defaultdata[0].value4 || ''
			this.defaultdata.forEach((item) => {
				myData.push(item[this.valueMap[0].key]);
				numA.push(item[this.valueMap[2].key]);
			});
			const xAxis = this.defaultdata.map((item) => {
				return item.value1;
			});

			const percent = (7 / xAxis.length) * 100;
			let zoom = [
				{
					id: "scope26", // 唯一的id
					filterMode: "empty",

					mayValueSpan: 7, // 显示数据的条数(默认显示10个)
					type: "slider",
					xAxisIndex: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。
					dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},

					backgroundColor: "transparent",
					fillerColor: "transparent",
					borderColor: "transparent",
					start: 0,
					end: percent,
					top: "80%",
					height: "5%",
				},
			];
			var Toption = {
				title: [
					{
						text: unit,
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				legend: [
					{
						top: "2%",
						right: 50,
						itemHeight: 12, //图例的高度  文字左边那个
						itemWidth: 10,
						icon: "rect",
						textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
						data: [this.defaultdata[0].value2 || ""],
					},
				],
				grid: {
					left: "5px",
					right: "10px",
					bottom: "0px",
					top: "40px",
					containLabel: true,
				},
				xAxis: {
					type: "category",
					boundaryGap: true,
					data: myData,
					axisLabel: {
						interval: 0,
						width: 50,
						overflow: 'truncate', //文字超出宽度截断，默认为...
						
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
							fontSize: "14",
							lineHeight: 16,
						},
						formatter: function (value) {
							return value
						},
					},
					axisLine: {
						lineStyle: {
							// X 轴颜色配置
							color: "#4792e9",
						},
					},
					axisTick: {
						show: false,
					},
				},
				yAxis: {
					type: "value",
					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
						},
					},
					axisLine: {
						show: false,
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
				},
				series: [
					{
						name: this.defaultdata[0].value2,
						type: "bar",
						smooth: true,
						stack: "Total",
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0,
											color: "#00e3e2", // 0% 处的颜色
										},
										{
											offset: 0.8,
											color: "#00e3e2", // 0% 处的颜色
										},
										{
											offset: 1,
											color: "#02323d", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						symbolSize: 0,
						label: {
							show: true,
							position: "top",
							offset: [0, -3], // 添加偏移属性
							textStyle: {
								//设置文本样式
								color: "#CBD8DE",
							},
						},
						// 设置 markPoint 来模拟 T 型顶部
						markPoint: {
							data: numA.map((value, index) => ({
								coord: [myData[index], value],
								symbol: "rect",
								symbolSize: [22, 2],
								// symbolOffset: [10 + index * 2, -10 - index * 2], // 根据索引调整偏移量
								symbolOffset: [0, -3], // 在 x 方向偏移 10 像素，在 y 方向偏移 -10 像素
								itemStyle: {
									color: "#fff",
								},
							})),
						},
						data: numA,
						barWidth: 15,
						barGap: "40%",
					},
				],
				dataZoom: xAxis.length > 7 ? zoom : [],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		// this.$nextTick(() => {
		this.DrawEcharts(); //需要刷新的数据
		// });
	},
}
</script>

<style scoped>
.lb {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	padding: 10px 0;
}

.barMian {
	width: 100%;
	height: 100%;
}
</style>
